import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SwedishMassagePage = lazy(() => import('../pages/services/swedish-massage/page'));
const PrenatalMassagePage = lazy(() => import('../pages/services/prenatal-massage/page'));
const PainReliefMassagePage = lazy(() => import('../pages/services/pain-relief-massage/page'));
const LymphaticDrainagePage = lazy(() => import('../pages/services/lymphatic-drainage/page'));
const CuppingTherapyPage = lazy(() => import('../pages/services/cupping-therapy/page'));
const RedLightTherapyPage = lazy(() => import('../pages/services/red-light-therapy/page'));
const MobileMassagePage = lazy(() => import('../pages/mobile-massage/page'));
const InHomeMassagePage = lazy(() => import('../pages/mobile-massage/in-home-massage/page'));
const AtHomePrenatalPage = lazy(() => import('../pages/mobile-massage/at-home-prenatal/page'));
const CorporateMassagePage = lazy(() => import('../pages/corporate-massage/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post/page'));
const ServiceAreasPage = lazy(() => import('../pages/areas/page'));
const MesaPage = lazy(() => import('../pages/areas/mesa/page'));
const GilbertPage = lazy(() => import('../pages/areas/gilbert/page'));
const ChandlerPage = lazy(() => import('../pages/areas/chandler/page'));
const TempePage = lazy(() => import('../pages/areas/tempe/page'));
const ApacheJunctionPage = lazy(() => import('../pages/areas/apache-junction/page'));
const ScottsdalePage = lazy(() => import('../pages/areas/scottsdale/page'));
const PhoenixPage = lazy(() => import('../pages/areas/phoenix/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AboutPage = lazy(() => import('../pages/about/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const PlaybookPage = lazy(() => import('../pages/playbook/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const LogoDownloadPage = lazy(() => import('../pages/logo-download/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/services/swedish-massage',
    element: <SwedishMassagePage />
  },
  {
    path: '/services/prenatal-massage',
    element: <PrenatalMassagePage />
  },
  {
    path: '/services/pain-relief-massage',
    element: <PainReliefMassagePage />
  },
  {
    path: '/services/lymphatic-drainage',
    element: <LymphaticDrainagePage />
  },
  {
    path: '/services/cupping-therapy',
    element: <CuppingTherapyPage />
  },
  {
    path: '/services/red-light-therapy',
    element: <RedLightTherapyPage />
  },
  {
    path: '/mobile-massage',
    element: <MobileMassagePage />
  },
  {
    path: '/mobile-massage/in-home-massage',
    element: <InHomeMassagePage />
  },
  {
    path: '/mobile-massage/at-home-prenatal',
    element: <AtHomePrenatalPage />
  },
  {
    path: '/corporate-massage',
    element: <CorporateMassagePage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />
  },
  {
    path: '/areas',
    element: <ServiceAreasPage />
  },
  {
    path: '/areas/mesa',
    element: <MesaPage />
  },
  {
    path: '/areas/gilbert',
    element: <GilbertPage />
  },
  {
    path: '/areas/chandler',
    element: <ChandlerPage />
  },
  {
    path: '/areas/tempe',
    element: <TempePage />
  },
  {
    path: '/areas/apache-junction',
    element: <ApacheJunctionPage />
  },
  {
    path: '/areas/scottsdale',
    element: <ScottsdalePage />
  },
  {
    path: '/areas/phoenix',
    element: <PhoenixPage />
  },
  {
    path: '/pricing',
    element: <PricingPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/settings',
    element: <SettingsPage />
  },
  {
    path: '/playbook',
    element: <PlaybookPage />
  },
  {
    path: '/logo-download',
    element: <LogoDownloadPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;